import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";
import { list as getCustomPointTypes } from "sources/books/customPointTypes";

const config = {
    checkVisitingTime: {
        label: "Время проверки посещения",
        required: true,
        validators: [requiredField],
        inputProps: { name: "checkVisitingTime", type: "time", skip: 600, placeholder: "08:00" },
    },
    checkLatenessTime: {
        label: "Время проверки успеваемости",
        required: true,
        validators: [requiredField],
        inputProps: { name: "checkLatenessTime", type: "time", skip: 600, placeholder: "16:00" },
    },
    planDailyMileage: {
        label: "Плановый ежедневный пробег",
        inputProps: { name: "planDailyMileage" },
    },
    customPointTypeIds: {
        isSelect: true,
        isMulti: true,
        url: getCustomPointTypes,
        label: "Типы маршрутных точек для уменьшения пробега на смену",
        inputProps: { name: "customPointTypeIds" },
        propName: "name",
    },
    maxMileageAfterCustomPoint: {
        label: "Значение уменьшения пробега",
        inputProps: { name: "maxMileageAfterCustomPoint" },
    },
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
